import pathToRegexp from 'path-to-regexp';
import i18n from 'i18next';

const projectPath = '/projects/:projectid/(.*)';
const locationPath = '/site-locations/:projectid/(.*)';


const genericPrefixes = ['', 'templates', 'supplies', 'invoices', 'jobs'];

const getCurrentURL = () => new URL(window.location);
const getCurrentPath = () => getCurrentURL().pathname.split('/');
const stripEmptyPath = (path = []) => path.filter(p => p.length !== 0);
const getCleanPathArray = () => stripEmptyPath(getCurrentPath());
const removeTemplateSteps = (pathNodes) => {
  const hasTemplateSteps = pathNodes.findIndex(node => node === 'new');

  if (hasTemplateSteps >= 0) {
    pathNodes.splice(hasTemplateSteps, 2);
  }

  return pathNodes;
};

export const getSubdomain1FromPath = () => {
  const project = pathToRegexp(projectPath).exec(window.location.pathname);
  const siteLocation = pathToRegexp(locationPath).exec(window.location.pathname);

  if (project) {
    return decodeURIComponent(project[1]);
  } else if (siteLocation) {
    return decodeURIComponent(siteLocation[1]);
  }

  return undefined;
};

export const getSubdomain0FromPath = () => {
  const project = pathToRegexp(projectPath).exec(window.location.pathname);
  const siteLocation = pathToRegexp(locationPath).exec(window.location.pathname);

  if (project) {
    return 'projects';
  } else if (siteLocation) {
    return 'site-locations';
  }

  return undefined;
};

export const getIndexFromTabs = (tabs) => {
  const nodes = window.location.pathname.split('/');
  const values = Object.values(tabs);

  return values.findIndex((rawTab) => {
    const tab = rawTab
      .toLowerCase()
      .replace('/', '')
      .replace('resources/', '')
      .replace('manage-access/', '')
      .replace('overview', '')
      .replace('ecoc templates', 'templates')
      .replace(' ', '-');

    switch (nodes[1]) {
      case 'projects':
      case 'site-locations':
        return (nodes[3] === tab);
      case 'resources':
      case 'manage-access':
        return (nodes[2] === tab || i18n.t(`urls:${nodes[2]}`) === tab);
      default:
        return (nodes[1] === tab || i18n.t(`urls:${nodes[1]}`) === tab);
    }
  });
};

const isSpecificURL = () =>
  pathToRegexp(projectPath).test(window.location.pathname) ||
  pathToRegexp(locationPath).test(window.location.pathname);


export const getPathNode = () => {
  const pathNodes = getCleanPathArray();
  const index = isSpecificURL(pathNodes) ? 2 : 0;

  return pathNodes[index] || '';
};

export const getURL = (tab, strip = true) => {
  let pathNodes = getCleanPathArray();
  const index = isSpecificURL(pathNodes) ? 2 : 0;
  pathNodes[index] = tab;
  pathNodes = removeTemplateSteps(pathNodes);

  if (strip) {
    const stripIndex = pathNodes.findIndex(node => genericPrefixes.includes(node));
    pathNodes = pathNodes.slice(0, stripIndex + 1);
  }

  return `/${pathNodes.join('/')}`;
};

export const getStep = () =>
  getCleanPathArray().find(node => Number(node));



// WEBPACK FOOTER //
// ./src/helpers/urls.js